import { inject, Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'linkifyText',
  standalone: true,
})
export class LinkifyPipe implements PipeTransform {
  sanitizer = inject(DomSanitizer);

  transform(value: string | undefined | null): SafeHtml {
    if (!value) return '';

    // 1. Regex for URLs (http, https, and www)
    const urlRegex = /(https?:\/\/[^\s]+|www\.[^\s]+)/g;

    // 2. Regex for Email addresses
    const emailRegex = /([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/g;

    let transformedText = value;

    // Replace URLs
    transformedText = transformedText.replace(urlRegex, (url) => {
      const href = url.startsWith('http') ? url : `http://${url}`;
      return `<a href="${href}" target="_blank" rel="noopener noreferrer">${url}</a>`;
    });

    // Replace Emails
    transformedText = transformedText.replace(emailRegex, (email) => {
      return `<a href="mailto:${email}">${email}</a>`;
    });

    return this.sanitizer.bypassSecurityTrustHtml(transformedText);
  }
}
